import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";import { useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";

export const ProtectedRoute = ({ role, children }) => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
      </div>
    );
  if (!user) return <Login portal={role} />;
  if (user.role !== role) return <Login portal={role} />;
  return children;
};
